export const DateFormat_M_D_YYYY = 'M/D/YYYY'; // 1/2/2020
